(function() {
  var Filter,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

  Filter = App.loadClass('core::Angular/ReportFilters/Filter');

  exports.Sidebar = (function() {
    function Sidebar(definitions) {
      var group, i, len;
      if (definitions == null) {
        definitions = [];
      }
      this.exportStructure = bind(this.exportStructure, this);
      this.moveFilter = bind(this.moveFilter, this);
      this.clearFilters = bind(this.clearFilters, this);
      this.jsonize = bind(this.jsonize, this);
      this.clearFiltersBelow = bind(this.clearFiltersBelow, this);
      this.findInGroup = bind(this.findInGroup, this);
      this.populateSidebar = bind(this.populateSidebar, this);
      this.assignGroupName = bind(this.assignGroupName, this);
      this.enableGroup = bind(this.enableGroup, this);
      this.disableGroup = bind(this.disableGroup, this);
      this.showGroup = bind(this.showGroup, this);
      this.hideGroup = bind(this.hideGroup, this);
      this.removeGroup = bind(this.removeGroup, this);
      this.importGroup = bind(this.importGroup, this);
      this.recent_fetch_url = null;
      this.groups = [];
      for (i = 0, len = definitions.length; i < len; i++) {
        group = definitions[i];
        this.importGroup(group);
      }
    }


    /*
    Imports a new filter group and it's child filters
     */

    Sidebar.prototype.importGroup = function(group) {
      var f, filters, i, len, ref;
      filters = [];
      ref = group.filters;
      for (i = 0, len = ref.length; i < len; i++) {
        f = ref[i];
        filters.push(new Filter(this, f));
      }
      group.filters = filters;
      group.visible = true;
      if (group.display_name == null) {
        group.display_name = group.name;
      }
      return this.groups.push(group);
    };


    /*
    Removes a filter group from the sidebar
     */

    Sidebar.prototype.removeGroup = function(name) {
      if (this.groups == null) {
        return false;
      }
      _.remove(this.groups((function(_this) {
        return function(grp) {
          return grp.name === name;
        };
      })(this)));
      return true;
    };


    /*
    Hide a filter group in the sidebar
     */

    Sidebar.prototype.hideGroup = function(name) {
      var group;
      if (this.groups == null) {
        return false;
      }
      group = _.find(this.groups, {
        'name': name
      });
      group.visible = false;
      return true;
    };


    /*
    Show a filter group in the sidebar
     */

    Sidebar.prototype.showGroup = function(name) {
      var group;
      if (this.groups == null) {
        return false;
      }
      group = _.find(this.groups, {
        'name': name
      });
      group.visible = true;
      return true;
    };


    /*
    Disable a filter group in the sidebar
        NB. Disabling a filter also hides it
     */

    Sidebar.prototype.disableGroup = function(name) {
      var group;
      this.hideGroup(name);
      group = _.find(this.groups, {
        'name': name
      });
      if (group != null) {
        return _.each(group.filters, (function(_this) {
          return function(fltr) {
            return fltr.disableFilter();
          };
        })(this));
      }
    };


    /*
    Enable a filter group in the sidebar
        NB. Enabling a filter also shows it
     */

    Sidebar.prototype.enableGroup = function(name) {
      var group;
      this.showGroup(name);
      group = _.find(this.groups, {
        'name': name
      });
      if (group != null) {
        return _.each(group.filters, (function(_this) {
          return function(fltr) {
            return fltr.enableFilter();
          };
        })(this));
      }
    };


    /*
    Assign a new display name to filter group
     */

    Sidebar.prototype.assignGroupName = function(old_name, new_name) {
      var group;
      if (this.groups == null) {
        return false;
      }
      group = _.find(this.groups, {
        'name': old_name
      });
      group.display_name = new_name;
      return true;
    };

    Sidebar.prototype.populateSidebar = function(data, cb) {
      var f, filter, values;
      if (cb == null) {
        cb = null;
      }
      for (filter in data) {
        values = data[filter];
        f = this.findInGroup(filter);
        if (f !== false) {
          f.populateValues(values);
        }
      }
      if (cb != null) {
        return cb();
      }
    };


    /*
    Shortcut for finding a filter without knowing which group
    it belongs to
     */

    Sidebar.prototype.findInGroup = function(filter_name, cut) {
      var filter, group, i, len, ref;
      if (cut == null) {
        cut = false;
      }
      if (this.groups == null) {
        return false;
      }
      ref = this.groups;
      for (i = 0, len = ref.length; i < len; i++) {
        group = ref[i];
        filter = _.find(group.filters, {
          'name': filter_name
        });
        if (filter != null) {
          if (cut) {
            group.filters = _.remove(group.filters, (function(_this) {
              return function(fltr) {
                return fltr.name = filter_name;
              };
            })(this));
          }
          return filter;
        }
      }
      return false;
    };


    /*
    Remove all selected values from filters that depend on given
     */

    Sidebar.prototype.clearFiltersBelow = function(filter) {
      var f, g, i, len, ref, remove, results;
      remove = false;
      ref = this.groups;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        g = ref[i];
        results.push((function() {
          var j, len1, ref1, ref2, results1;
          ref1 = g.filters;
          results1 = [];
          for (j = 0, len1 = ref1.length; j < len1; j++) {
            f = ref1[j];
            if (filter.name === f.name) {
              remove = true;
              continue;
            }
            if (f.deletable && remove && ((ref2 = f.control_type) !== 'range' && ref2 !== 'datepicker' && ref2 !== 'date_range')) {
              results1.push(f.selected_values = []);
            } else {
              results1.push(void 0);
            }
          }
          return results1;
        })());
      }
      return results;
    };


    /*
    Converts our structure into a nicely passable format for
    both fetching new filters and for running report queries
    Inactive querys need to be included sent when computing filters
    but not when computing report or excel exports
     */

    Sidebar.prototype.jsonize = function(includeInactive) {
      var arr, end, f, g, i, j, k, key, len, len1, len2, ref, ref1, ref2, start, sv, vals;
      if (includeInactive == null) {
        includeInactive = false;
      }
      arr = {};
      ref = this.groups;
      for (i = 0, len = ref.length; i < len; i++) {
        g = ref[i];
        ref1 = g.filters;
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          f = ref1[j];
          if (f.enabled) {
            vals = [];
            if (f.control_type === 'range') {
              vals = {
                key: {
                  min: f.low_range,
                  max: f.high_range
                }
              };
            } else if (f.control_type === 'date_range') {
              start = f.daterange.startDate;
              end = f.daterange.endDate;
              vals = {
                key: {
                  start: start != null ? start.format() : null,
                  end: end != null ? end.format() : null
                }
              };
            } else {
              ref2 = f.selected_values;
              for (k = 0, len2 = ref2.length; k < len2; k++) {
                sv = ref2[k];
                if (includeInactive || sv.isSelectedInParent()) {
                  key = sv.key;
                  if (typeof key === 'object') {
                    key = JSON.stringify(key);
                  }
                  vals.push({
                    key: encodeURIComponent(key),
                    value: encodeURIComponent(sv.value)
                  });
                }
              }
            }
            arr[f.name] = vals;
          }
        }
      }
      return {
        filters: arr
      };
    };

    Sidebar.prototype.clearFilters = function() {
      var f, fg, i, len, ref, results;
      ref = this.groups;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        fg = ref[i];
        results.push((function() {
          var j, len1, ref1, results1;
          ref1 = fg.filters;
          results1 = [];
          for (j = 0, len1 = ref1.length; j < len1; j++) {
            f = ref1[j];
            if (f.deletable) {
              f.selected_values = [];
              f.low_range = '';
              f.high_range = '';
              results1.push(f.daterange = {
                startDate: null,
                endDate: null
              });
            } else {
              results1.push(void 0);
            }
          }
          return results1;
        })());
      }
      return results;
    };


    /*
    Move a filter from one group to another
    filter: name of filter to move
    to:     name of group to move filter to
    after:  name of filter before which the moved filter shall be put
            if after is null then the filter will be put at the top of the group
    returns:  true if filter was successfully moved
     */

    Sidebar.prototype.moveFilter = function(filter_name, to_group, before) {
      var f, filter, group, i, index, len, ref;
      if (before == null) {
        before = null;
      }
      filter = this.findInGroup(filter_name, true);
      if (!filter) {
        return false;
      }
      group = _.find(this.groups, {
        'name': to_group
      });
      if (before != null) {
        ref = group.filters;
        for (index = i = 0, len = ref.length; i < len; index = ++i) {
          f = ref[index];
          if (f.name === before) {
            g.filters.splice(index, 0, filter);
          }
        }
      } else {
        group.filters.unshift(filter);
      }
      return true;
    };


    /*
    Returns original filter structure (aka what is seen in the report fluent filter)
    ignoredFltrs: array of filter names to exclude
    ignoredGrps: array of group names to exclude
     */

    Sidebar.prototype.exportStructure = function(ignoredFltrs, ignoredGrps) {
      var attr, f, filter, g, group, i, j, len, len1, ref, ref1, structure, value;
      if (ignoredFltrs == null) {
        ignoredFltrs = [];
      }
      if (ignoredGrps == null) {
        ignoredGrps = [];
      }
      structure = [];
      ref = this.groups;
      for (i = 0, len = ref.length; i < len; i++) {
        g = ref[i];
        if (ignoredGrps.indexOf(g.name) === -1) {
          group = {
            name: g.name,
            display_name: g.display_name,
            filters: []
          };
          ref1 = g.filters;
          for (j = 0, len1 = ref1.length; j < len1; j++) {
            f = ref1[j];
            if (ignoredFltrs.indexOf(f.name) === -1) {
              filter = [];
              for (attr in f) {
                value = f[attr];
                filter[attr] = value;
              }
              group.filters.push(filter);
            }
          }
          structure.push(group);
        }
      }
      return structure;
    };

    return Sidebar;

  })();

}).call(this);
